import { Work, WorkType } from '@/types/work'
import moment from 'moment-timezone'
import { CalendarEventType, EventCalendar } from '@/types/Calendar'
import slotStyles from '../calendar/calendarStaff/staffWork/staffWorkDayCell.module.scss'

export function dataWorks(works: Work[]): EventCalendar[] {
    return works.map((work: Work) => {
        const start: string = moment(work.start, 'HH:mm:ss').format('HH:mm')
        const end: string = moment(work.end, 'HH:mm:ss').format('HH:mm')

        return {
            title: `${work.sectionGroupName ? work.sectionGroupName : ''}`,
            start: moment(
                moment(work.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + start,
                'YYYY-MM-DD HH:mm'
            ).toDate(),
            end: moment(moment(work.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + end, 'YYYY-MM-DD HH:mm').toDate(),
            number: '',
            type: defineWorkTypeToCalendarEventType(work.type),
            slots: work,
            levelId: work.staffLevelId || undefined,
            staffId: work.staff || undefined
        }
    })
}

export function defineWorkTypeToCalendarEventType(type: WorkType): CalendarEventType {
    switch (type) {
        case WorkType.notInSection:
            return CalendarEventType.NOT_IN_SECTION
        case WorkType.holiday:
            return CalendarEventType.STAFF_HOLIDAY
        case WorkType.training:
            return CalendarEventType.STAFF_TRAINING
        default:
            return CalendarEventType.IN_SECTION
    }
}

export function defineWorkTypeStyle(type: CalendarEventType): string {
    switch (type) {
        case CalendarEventType.NOT_IN_SECTION:
            return slotStyles.NotInSection
        case CalendarEventType.STAFF_HOLIDAY:
            return slotStyles.StaffHoliday
        case CalendarEventType.STAFF_TRAINING:
            return slotStyles.StaffTraining
        default:
            return ''
    }
}
